<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="所属流程" prop="nodeKey">
          {{ form.nodeKey || '' }}

        </el-form-item>
        <el-form-item label="节点名称" prop="nodeName">
          {{ form.nodeName || '' }}

        </el-form-item>

        <el-form-item label="节点审批角色" prop="nodeRoleName">
          {{ form.nodeRoleName || '' }}
        </el-form-item>
        <el-form-item label="驳回节点" prop="upNode">
          {{ form.upNode || '' }}
        </el-form-item>
        <el-form-item label="下一个节点" prop="nextNode">
          {{ form.nextNode || '' }}
        </el-form-item>
        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>

        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>

export default {

  name: 'FlowManageAdd',
  data () {
    return {

      form: {
        nodeId: '',
        nodeKey: '',
        nodeName: '',
        nodeRole: '',
        nextNode: '',
        upNode: ''

      }

    }
  },
  computed: {
    nodeId () {
      return this.$route.query.nodeId
    }

  },
  created () {
    if (this.nodeId) {
      this.loadDetails()
    }
  },
  methods: {

    loadDetails () {
      this.loading = true
      this.$axios
        .get(this.$apis.flowManage.selectYgNodeByNodeId, {
          params: { nodeId: this.nodeId }
        })
        .then(res => {
          this.form = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 400px;
}
</style>
